// extracted by mini-css-extract-plugin
export default {"button":"PromotionsTable__button-IGzHZ"};